module.exports = __webpack_public_path__ + "media/images/cleaning/cover-desktop@2x-7ac6af1cbe258a58c31b8e8ef3c741af.jpg";